@if ($hasSidebar()) {
    <meta-sidebar [menuItems]="sidebarMenuItems" [userMenuItems]="sidebarUserMenuItems" [activeItem]="activeItem$ | async"
        [hideUserMenu]="config.hideUserMenu || false" (statusChanged)="$sideBarShown.set($event)"
        (menuItemClicked)="handleMenuItemClicked($event.id)" (userMenuItemClicked)="handleUserMenuItemClicked($event.id)" />
}

<main id="mainContent" class="min-h-screen bg-body flex flex-col flex-1 transition-all duration-300 pb-6"
    [ngClass]="{'xl:pl-sidebar': $hasSidebar() && $sideBarShown()}">
    @if (!$hasSidebar()) {
        <header class="pt-6 pb-5 w-full flex justify-center bg-primary mb-10">
            <img class="max-h-[3.75rem] mx-auto" [src]="mainLogo" [alt]="name" role="presentation" />
        </header>
    }
    @if (aboutResult$ | async; as about) {
      <section class="pt-6 pb-3 bg-body px-base xl:px-base-desk mb-6 flex-1">
        <div class="flex flex-col-reverse lg:flex-row">
          <div class="w-full flex">
            <div>
              <h1 class="text-4xl font-bold">{{about.title | translate}}</h1>
            </div>
          </div>
          @if ($loggedIn() && !hideChatToggler) {
          <div class="flex mb-4 lg:pl-8 lg:ml-auto">
            <div class="ml-auto">
              <meta-chat-toggler />
            </div>
          </div>
          }
        </div>
        <div class="pt-3" [innerHTML]="about.body | translate">

        </div>
      </section>
    }

    <meta-footer [hideCustomFooter]="hideFooter" />
</main>
